export default "__VITE_ASSET__Bx$QLSf4__"